import React from 'react'
import styled from 'styled-components'
import { View } from '@olxbr/design-system'
import { Link } from '@olxbr/ds-web'
import { termosDeUso, politicaDePrivacidade } from '@olxbr/design-system/web/config/staticUrl'
import medias from '../../../util/medias'
import PropTypes from 'prop-types'

const Content = styled(View)`
  ${medias.small`padding: 0 16px 16px 16px;`}
`

export const termsAriaLabel = 'link para ler temos de uso'
export const privacyAriaLabel = 'link para ler política de privacidade'

const termsAndPrivacyNotice = ({ onTermsClick, onPrivacyClick }) => (
  <Content>
    <span className="typo-caption text-neutral-120">
      Ao continuar, você concorda com os{' '}
      <Link aria-label={termsAriaLabel} onClick={onTermsClick} size="caption" href={termosDeUso}>
        Termos de Uso
      </Link>
      &nbsp;e a{' '}
      <Link
        aria-label={privacyAriaLabel}
        onClick={onPrivacyClick}
        size="caption"
        href={politicaDePrivacidade}
      >
        Política de Privacidade
      </Link>
      &nbsp;da OLX e seus parceiros, e em receber comunicações da OLX.
    </span>
  </Content>
)

termsAndPrivacyNotice.propTypes = {
  onTermsClick: PropTypes.func,
  onPrivacyClick: PropTypes.func,
}

export default termsAndPrivacyNotice
